import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";

const ViewMessageModal = ({
  open,
  setOpen,
  message,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  message: string;
}) => {
  return (
    <Modal
      className="modal addCategory_modal"
      open={open}
      onClose={() => setOpen(false)}
    >
      <div className="modal-dialog" style={{ minWidth: "30%" }}>
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2>{"View Message"}</h2>
            <div
              role="button"
              tabIndex={0}
              className="btn-close"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon />
            </div>
          </div>
          <form
            className="form"
            onSubmit={(e) => {
              e.preventDefault(); // prevent default page reload
            }}
          >
            <div className="control_group w_100">
              <div className="user_block click_action">
                <p>
                  <b>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: message || "",
                      }}
                    />
                  </b>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default ViewMessageModal;
